<template>
  <b-modal
    ref="confirm-sync-video-modal"
    id="confirm-sync-video-modal"
    size="md"
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    body-class="pt-1 pb-2"
  >
    <div
      class="d-flex justify-content-between top-modal"
      style="margin-top: 10px;"
    >
      <h4 class="font-medium text-primary">
        Confirm upload video to ad account
      </h4>
    </div>
    <validation-observer
      ref="syncVideoValidation"
    >
      <b-form @submit.prevent="confirmSync">
        <b-form-group
          class="my-2 form-email"
        >
          <div class="d-flex justify-content-between">
            <label>
              Ad account
            </label>
          </div>
          <validation-provider
            #default="{ errors }"
            vid="email"
            rules="required"
            name="Ad account"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid':null"
            >
              <v-select
                v-model="adAccountSelected"
                label="name"
                class="ads-account-select"
                :options="adAccountOptions"
                :clearable="false"
                style="width: 100%"
                placeholder="Select ad account"
                @input="handelSelectAdAccount"
              >
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <feather-icon
                      icon="ChevronDownIcon"
                      size="13"
                    />
                  </span>
                </template>

                <template #option="{ name, value }">
                  <div class="d-flex justify-content-between mr-2">
                    <span
                      class="mb-0 wrap-content"
                      style="max-width: 200px;"
                    >
                      {{ name }}
                    </span>
                    <span class="mb-0">
                      {{ value }}
                    </span>
                  </div>
                </template>
              </v-select>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <btn-loading
            class="mr-1 border-0"
            variant-convert="btn-back"
            pill
            @click="hideModal"
          >
            Cancel
          </btn-loading>
          <btn-loading
            class="ml-1"
            variant-convert="btn-submit"
            type="submit"
            pill
            :loading="loading"
          >
            Confirm
          </btn-loading>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script lang="js">
import {
  BFormGroup, BInputGroup, BModal, BForm,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import vSelect from 'vue-select'
import { createNamespacedHelpers } from 'vuex'
import { toastification } from '@core/mixins/toast'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

const { mapActions, mapGetters } = createNamespacedHelpers('campaign')
export default {
  name: 'VideoGenerationLibrary',
  components: {
    BForm,
    BInputGroup,
    BFormGroup,
    BModal,
    BtnLoading,
    vSelect,

    // validation
    ValidationObserver,
    ValidationProvider,
  },

  mixins: [toastification],

  props: {
    videosSelected: {
      type: Array,
      default: () => [],
      required: true,
    },

    adAccounts: {
      type: Array,
      default: () => [],
      required: true,
    },
  },

  data() {
    return {
      required,

      adAccountSelected: null,
      adAccountOptions: [],
    }
  },

  computed: {
    ...mapGetters(['message', 'status', 'loading']),
  },

  watch: {
    adAccounts: {
      handler(val) {
        this.adAccountOptions = val.filter(item => item.isWhitelistUSPC).map(item => ({
          name: item.name,
          // eslint-disable-next-line no-underscore-dangle
          value: item._id,
        }))
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['syncVideoToAdAccount']),
    showModal() {
      this.$refs['confirm-sync-video-modal'].show()
    },

    hideModal() {
      this.adAccountSelected = null
      this.$refs['confirm-sync-video-modal'].hide()
    },

    handelSelectAdAccount() {
      this.$emit('selectAdAccount', this.adAccountSelected)
    },

    async confirmSync() {
      const success = await this.$refs.syncVideoValidation.validate()
      if (!success) return
      const params = {
        advertiserId: this.adAccountSelected.value,
        localVideoIds: this.videosSelected.map(video => video.id),
      }
      await this.syncVideoToAdAccount(params)
      if (this.status) {
        this.toastSuccess('Video synced successfully')
        this.hideModal()
        this.$emit('refreshLibrary')
      } else {
        this.toastFailure(this.message)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
